import React, { Fragment } from "react";
import { UserContext } from "../Definitions/UserContext";
import { NoRecordsBanner } from '../OopsBanner';


export default function RenderBusinessName({ data, layout = "default", siteData }: { data: any, layout: string, siteData: UserContext }) {
    if (data?.isStenciled) {
        const style = {
            maxHeight: "1em",
            overflow: "hidden",
            opacity: 1
        }
        return <div className="stenciled  flex-column gap-small">
            <div className='w-full stencil-item' style={style}>This page contains basic business name.</div>           
        </div>
    }

    else if (!data.businessName || data.businessName.length == 0)
        return <NoRecordsBanner message='Business Name is not available.' />

    const businessName = data.businessName;//.replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">");
    const ownerName = data.ownerName;


    let split = layout.split(";");
    let textLayout = split[0];
    let conentLayout = (split.length>1)?split[1]:"";

    let text = businessName;

    if (conentLayout == "owner") {
        text = ownerName;
    }
    else if(conentLayout == "both"){
        text = businessName + " - " + ownerName;
    }

    switch (textLayout) {

        case "h-1":
            return <h1 className="w-full name-text sub-inherit-color" dangerouslySetInnerHTML={{ __html: text }}></h1>
        case "h-2":
            return <h2 className="w-full name-text sub-inherit-color" dangerouslySetInnerHTML={{ __html: text }}></h2>
        case "h-3":
            return <h3 className="w-full name-text sub-inherit-color" dangerouslySetInnerHTML={{ __html: text }}></h3>
        case "h-4":
            return <h4 className="w-full name-text sub-inherit-color" dangerouslySetInnerHTML={{ __html: text }}></h4>
        case "p-1":
            return <p className="vp-1 w-full name-text sub-inherit-color" dangerouslySetInnerHTML={{ __html: text }}></p>
        case "p-2":
            return <p className="vp-2 w-full name-text sub-inherit-color" dangerouslySetInnerHTML={{ __html: text }}></p>
        case "p-3":
            return <p className="vp-3 w-full name-text sub-inherit-color" dangerouslySetInnerHTML={{ __html: text }}></p>
        case "default":
            return <span dangerouslySetInnerHTML={{ __html: text }}></span>
        default:
            return <span dangerouslySetInnerHTML={{ __html: text }}></span> //setting inner to handle special chars and emojies
    }
}
